import { render, staticRenderFns } from "./QuestionsCharts.component.vue?vue&type=template&id=50c792fa&scoped=true&"
import script from "./QuestionsCharts.component.vue?vue&type=script&lang=js&"
export * from "./QuestionsCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsCharts.component.vue?vue&type=style&index=0&id=50c792fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c792fa",
  null
  
)

export default component.exports